import React, { useRef, useState, useEffect } from "react";
import classNames from "classnames";

import useFocus from "fantastic/lib/useFocus";

const SelectTagsSetting = ({
  tags = [],
  label = i18n.t('tags'),
  onChange,
  values = [],
  locked = [],
  favorite = [],
  description
}) => {
  const isActiveTag = tag => values.includes(tag);
  const isLockedTag = tag => locked.includes(tag);
  const isFavoriteTag = tag => favorite.includes(tag);

  const tagsElm = useRef();
  const [inputElm, setInputFocus] = useFocus();

  const [active, setActive] = useState(false);

  const [value, setValue] = useState("");

  useEffect(() => {
    if (!active) return;

    setInputFocus();
  }, [active]);

  const renderTag = (tag, index) => {
    const klass = classNames("form-tags__tag", {
      "form-tags__tag--active": isActiveTag(tag),
      "form-tags__tag--locked": isLockedTag(tag),
      "form-tags__tag--favorite": isFavoriteTag(tag)
    });
    return (
      <div key={index} className={klass} onClick={() => onChange(tag)}>
        {tag}
      </div>
    );
  };

  const renderNewTag = () => {
    return (
      <div className="form-tags__new input-group btn-group btn-group-block">
        <input
          className="form-control"
          value={value}
          onChange={handleChangeValue}
          onKeyDown={handleKeyDown}
          ref={inputElm}
        />
        <button className="btn btn-form" onClick={appendNewTag}>{ i18n.t('add') }</button>
      </div>
    );
  };

  const handleClickTags = event => {
    if (event.target !== tagsElm.current && event.target !== inputElm.current) {
      setActive(false);
      return;
    }

    setActive(true);
    setInputFocus();
  };

  const handleChangeValue = event => setValue(event.target.value);
  const handleKeyDown = event => {
    if (event.keyCode !== 13) return;
    appendNewTag();
  };

  const appendNewTag = () => {
    onChange(value);
    setValue("");
    setActive(false);
  };

  return (
    <div className="form-group">
      <label>{label}</label>
      <div className="form-tags" onClick={handleClickTags} ref={tagsElm}>
        {!active && tags.map(renderTag)}
        {active && renderNewTag()}
      </div>
      {description && (
        <small className="form-text text-muted">
          {typeof description === "function"
            ? description(setActive)
            : description}
        </small>
      )}
    </div>
  );
};

export default SelectTagsSetting;
